export const MAIN_INFO_INPUTS = [
  'invoice',
  'startDate',
  'dueDate',
  'account',
  'customer',
  'notes',
  'bookingNumber',
];
